export class PaimonSinkProperties {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "primaryKeys",
            "baseName": "primaryKeys",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "bucket",
            "baseName": "bucket",
            "type": "number",
            "format": ""
        },
        {
            "name": "fileFormat",
            "baseName": "fileFormat",
            "type": "string",
            "format": ""
        },
        {
            "name": "parquetCompression",
            "baseName": "parquetCompression",
            "type": "string",
            "format": ""
        },
        {
            "name": "clusteringColumns",
            "baseName": "clusteringColumns",
            "type": "Array<string>",
            "format": ""
        },
        {
            "name": "clusteringStrategy",
            "baseName": "clusteringStrategy",
            "type": "PaimonClusteringStrategy",
            "format": ""
        },
        {
            "name": "icebergMetadataStorage",
            "baseName": "icebergMetadataStorage",
            "type": "string",
            "format": ""
        },
        {
            "name": "icebergRest",
            "baseName": "icebergRest",
            "type": "PaimonRestCatalogConfig",
            "format": ""
        },
        {
            "name": "retention",
            "baseName": "retention",
            "type": "TableRetentionConfig",
            "format": ""
        },
        {
            "name": "extraOptions",
            "baseName": "extraOptions",
            "type": "{ [key: string]: string; }",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return PaimonSinkProperties.attributeTypeMap;
    }
    constructor() {
    }
}
